<template>
  <div class="enterprise-layout">
    <EnterpriseHeader v-if="isEnterpriseHome" />
    <LayoutHeader v-else :is-workbench="true" />
    <main id="enterprise-layout-content" class="enterprise-layout__content">
      <slot />
      <EnterpriseFooter />
    </main>
  </div>
</template>

<script setup lang="ts">
import EnterpriseHeader from '~/components/Index/enterprise/EnterpriseHeader.vue'
import EnterpriseFooter from '~/components/Index/enterprise/EnterpriseFooter.vue'

const route = useRoute()
const localePath = useLocalePath()
const normalizePath = (path: string) => path.replace(/\/+$/, '') || '/'
const isEnterpriseHome = computed(() => normalizePath(route.path) === normalizePath(localePath('/')))
</script>

<style lang="scss">
.enterprise-layout {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #fff;
  color: #1f2329;
  font-family: Inter, "PingFang SC", "Microsoft YaHei", sans-serif;

  &__content {
    flex: 1;
    min-width: 0;
    overflow-x: hidden;
    overflow-y: auto;
    scroll-behavior: smooth;
  }
}
</style>
